<template>
    <v-dialog :value="show" persistent max-width="80%" style="border-radius: 10px" @input="$emit('close')">
        <v-card>
            <v-card-title class="headline">
                <span style="color: #4a4a4a">{{ $t('passengers.qrCodeSendResult.title') }}</span>
            </v-card-title>
            <v-card-text>
                <div class="mb-4">
                    <strong>{{ summaryText }}</strong>
                </div>
                <merus-data-table
                    :headers="headersWithProperties"
                    :items="tableItems"
                    dense
                    class="elevation-7"
                    locale="pt"
                    style="border-radius: 10px"
                    :loading-text="$t('system.messages.loading')"
                >
                    <template v-slot:item.status_extenso="{ item }">
                        <span :class="{ 'error--text': !item.sucesso, 'success--text': item.sucesso }">
                            {{ item.status_extenso }}
                        </span>
                    </template>
                    <template v-slot:item.mensagem="{ item }">
                        <span :class="{ 'error--text': !item.sucesso }">{{ item.mensagem }}</span>
                    </template>
                </merus-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="downloadLog">{{ $t('passengers.qrCodeSendResult.downloadLog') }}</v-btn>
                <v-btn color="primary" class="white--text" @click="close">{{ $t('button.close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import MerusDataTable from '../Tables/MerusDataTable.vue';

export default {
    name: 'QrCodeSendResultDialog',
    components: {
        MerusDataTable,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        results: {
            type: Array,
            default() {
                return [];
            },
        },
        summary: {
            type: Object,
            default() {
                return { total: 0, sucessos: 0, erros: 0 };
            },
        },
    },
    computed: {
        summaryText() {
            return this.$t('passengers.qrCodeSendResult.summary', {
                sucessos: this.summary.sucessos || 0,
                erros: this.summary.erros || 0,
                total: this.summary.total || 0,
            });
        },
        headers() {
            return [
                { text: this.$t('passengers.qrCodeSendResult.headers.name'), value: 'nome_completo' },
                { text: this.$t('passengers.qrCodeSendResult.headers.registration'), value: 'matricula' },
                { text: this.$t('passengers.qrCodeSendResult.headers.email'), value: 'email' },
                { text: this.$t('passengers.qrCodeSendResult.headers.status'), value: 'status_extenso' },
                { text: this.$t('passengers.qrCodeSendResult.headers.message'), value: 'mensagem' },
            ];
        },
        headersWithProperties() {
            return this.headers.map((header) => ({
                ...header,
                filtrable: true,
                sortable: true,
            }));
        },
        tableItems() {
            return (this.results || []).map((item) => ({
                ...item,
                status_extenso: item.sucesso
                    ? this.$t('passengers.qrCodeSendResult.statusSuccess')
                    : this.$t('passengers.qrCodeSendResult.statusFailure'),
            }));
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        buildLogContent() {
            const dt = new Date();
            const separator = '-'.repeat(80);
            let content = 'LOG DE ENVIO DE QR CODE\n';
            content += `${separator}\n`;
            content += `Data/Hora: ${dt.toLocaleString()}\n`;
            content += `Total: ${this.summary.total || 0} | Sucessos: ${this.summary.sucessos || 0} | Falhas: ${this.summary.erros || 0}\n`;
            content += `${separator}\n\n`;

            this.tableItems.forEach((item, index) => {
                const status = item.sucesso
                    ? this.$t('passengers.qrCodeSendResult.statusSuccess').toUpperCase()
                    : this.$t('passengers.qrCodeSendResult.statusFailure').toUpperCase();
                content += `[${index + 1}] ${item.nome_completo || 'N/A'} | ${item.matricula || 'N/A'} | ${item.email || 'N/A'} | ${status} | ${item.mensagem || ''}\n`;
            });

            content += `\n${separator}\n`;
            content += 'FIM DO LOG\n';
            content += `${separator}\n`;
            return content;
        },
        downloadLog() {
            const dt = new Date();
            const timestamp = dt.getFullYear().toString()
                + (dt.getMonth() + 1).toString().padStart(2, '0')
                + dt.getDate().toString().padStart(2, '0')
                + dt.getHours().toString().padStart(2, '0')
                + dt.getMinutes().toString().padStart(2, '0')
                + dt.getSeconds().toString().padStart(2, '0');
            const filename = `envio-qrcode-${timestamp}.log`;
            const blob = new Blob([this.buildLogContent()], { type: 'text/plain;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
    },
};
</script>
